import { Box, Grid, Typography } from "@mui/material";
import { ArrowRight } from "lucide-react";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import AssetCard from "../../assets/components/AssetCard";
import { MissingAssetsPlaceholder } from "../../assets/components/MissingAssetsPlaceholder";
import Button from "../../common/components/Button";
import { SPACING } from "../../common/constants/spacing";

export const AssetsList = ({ assets, loading }) => {
  const { t } = useTranslation("assets");
  const navigate = useNavigate();
  const DASHBOARD_ASSETS_LIMIT = 9;

  // Show only first 6 assets on dashboard
  const displayedAssets = assets?.slice(0, DASHBOARD_ASSETS_LIMIT) || [];

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: SPACING.sm,
          mt: 6,
        }}
      >
        <Typography variant="h2" sx={{ fontWeight: 600 }}>
          {t("title")}
        </Typography>
        <Button
          variant="text"
          size="small"
          onClick={() => navigate("/assets")}
          sx={{
            textTransform: "none",
            color: "primary.main",
            py: 0.3,
            fontSize: "1rem",
          }}
          endIcon={<ArrowRight size={18} />}
        >
          {t("viewAll")}
        </Button>
      </Box>

      {loading ? (
        <div className="d-flex justify-content-center py-5">
          <Spinner animation="border" />
        </div>
      ) : assets?.length > 0 ? (
        <Grid container spacing={3}>
          {displayedAssets.map((asset) => (
            <AssetCard asset={asset} key={asset.id} />
          ))}
        </Grid>
      ) : (
        <MissingAssetsPlaceholder />
      )}
    </>
  );
};
